import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { IPaymentMethodsState, SLICE_NAME, initialState } from './models';
import { getPaymentMethods, updatePaymentMethod } from './actionCreators';

export const paymentMethodsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethods.fulfilled, (state: IPaymentMethodsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.paymentMethods = payload;
      })
      .addCase(updatePaymentMethod.fulfilled, (state: IPaymentMethodsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        if (state?.paymentMethods) {
          state.paymentMethods = state.paymentMethods.map((method) => (method.id === payload.id ? payload : method));
        }
      })
      .addMatcher(isPending(getPaymentMethods, updatePaymentMethod), (state: IPaymentMethodsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getPaymentMethods, updatePaymentMethod), (state: IPaymentMethodsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
